import { memo } from "react";
import {
  FormDataType,
  FormErrorsType,
  FormValidationFunctions,
} from "../types";
import { sortedBeneficiaryDetailsRecord } from "@zenith/pages/BeneficiariesPage/beneficiaries-page/beneficiaries-page";
import WalletTransferForm from "./WalletTransferForm";
import BankTransferForm from "./BankTransferForm";

interface TransferFormProps extends FormValidationFunctions {
  formData: FormDataType;
  formErrors: FormErrorsType;
  bankList: { value: string; label: string }[];
  isLoadingBanks: boolean;
  bankListError: boolean;
  categoryList: { value: string; label: string }[];
  beneficiaryList?: sortedBeneficiaryDetailsRecord[];
  isLoadingBeneficiaries: boolean;
  beneficiariesError: boolean;
  showBeneficiaryList: boolean;
  selectedBeneficiary?: sortedBeneficiaryDetailsRecord;
  transferOption: "bank" | "wallet";
  isLoading: boolean;
  availableLimit: number;
  availableBalance: number;
  saveBeneficiary: boolean;
  setFormData: React.Dispatch<React.SetStateAction<FormDataType>>;
  onSubmit: () => void | Promise<void>;
  onTransferOptionChange: (option: "bank" | "wallet") => void;
  onSaveBeneficiaryChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFormDataChange: (field: keyof FormDataType, value: string | number) => void;
  onBeneficiarySelect: (beneficiary: sortedBeneficiaryDetailsRecord) => void;
  onShowBeneficiaryList: () => void;
  validateAccountNumber: (accountNumber: string) => Promise<boolean>;
  validateAmount: (amount: number) => void;
  isValidating?: boolean;
}

const TransferForm = memo(function TransferForm({
  formData,
  formErrors,
  bankList,
  isLoadingBanks,
  bankListError,
  categoryList,
  beneficiaryList,
  selectedBeneficiary,
  isLoadingBeneficiaries,
  beneficiariesError,
  showBeneficiaryList,
  availableLimit,
  availableBalance,
  transferOption,
  saveBeneficiary,
  onSubmit,
  isLoading,
  onTransferOptionChange,
  onSaveBeneficiaryChange,
  onFormDataChange,
  onBeneficiarySelect,
  onShowBeneficiaryList,
  validateAccountNumber,
  validateAmount,
  isValidating = false,
}: TransferFormProps) {
  return (
    <div className="flex flex-col gap-4">
      {transferOption === "bank" ? (
        <BankTransferForm
          formData={formData}
          formErrors={formErrors}
          bankList={bankList}
          isLoadingBanks={isLoadingBanks}
          bankListError={bankListError}
          categoryList={categoryList}
          beneficiaryList={beneficiaryList}
          selectedBeneficiary={selectedBeneficiary}
          isLoadingBeneficiaries={isLoadingBeneficiaries}
          beneficiariesError={beneficiariesError}
          showBeneficiaryList={showBeneficiaryList}
          availableLimit={availableLimit}
          availableBalance={availableBalance}
          saveBeneficiary={saveBeneficiary}
          onSubmit={onSubmit}
          isLoading={isLoading}
          onSaveBeneficiaryChange={onSaveBeneficiaryChange}
          onFormDataChange={onFormDataChange}
          onBeneficiarySelect={onBeneficiarySelect}
          onShowBeneficiaryList={onShowBeneficiaryList}
          validateAccountNumber={validateAccountNumber}
          validateAmount={validateAmount}
          isValidating={isValidating}
        />
      ) : (
        <WalletTransferForm
          formData={formData}
          formErrors={formErrors}
          categoryList={categoryList}
          availableLimit={availableLimit}
          availableBalance={availableBalance}
          isLoading={isLoading}
          onSubmit={onSubmit}
          onFormDataChange={onFormDataChange}
          validateAccountNumber={validateAccountNumber}
          validateAmount={validateAmount}
          onBeneficiarySelect={onBeneficiarySelect}
          onShowBeneficiaryList={onShowBeneficiaryList}
          beneficiaryList={beneficiaryList}
          selectedBeneficiary={selectedBeneficiary}
          isLoadingBeneficiaries={isLoadingBeneficiaries}
          beneficiariesError={beneficiariesError}
          showBeneficiaryList={showBeneficiaryList}
          onSaveBeneficiaryChange={onSaveBeneficiaryChange}
          saveBeneficiary={saveBeneficiary}
          isValidating={isValidating}
        />
      )}
    </div>
  );
});

export default TransferForm;